import axios from 'axios';
// import setAuthToken from '../utils/setAuthToken';
import jwt_decode from 'jwt-decode';

import { USER_RESET_PASSWORD_SUCCESS, USER_CHANGE_PASSWORD_SUCCESS, GET_ERRORS, SET_CURRENT_USER, REGISTER_USER_SUCCESS, GET_USER_INFO_SUCCESS, GET_USER_INFO_LOADING, USER_LOGOUT, USER_RESET } from './types';
import { ToastContainer, toast } from 'react-toastify';

// Register User
export const registerUser = (userData) => dispatch => {
  axios
    .post('/api/users/register', userData)
    .then(res => {
      dispatch({
        type: REGISTER_USER_SUCCESS,
        payload: res.data
      })
      toast.success('User register success.');
    })
    .catch(err =>
      {
        toast.error(`${err.response.data.message}`);
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data
        })
    }
    );
};

export const getUserInfo = (history) => dispatch => {
  dispatch(setGetUserInfoLoading());

  axios
    .get('/api/users/current')
    .then(res => {
        console.log(res);
        dispatch({
          type: GET_USER_INFO_SUCCESS,
          payload: res.data
        })
      }
    )
    .catch(err => {
        // console.log(err.response.data);
      }
    );
};

// Register User
export const changePassword = (userData) => dispatch => {
  axios
    .post('/api/users/change_password', userData)
    .then(res => {
      dispatch({
        type: USER_CHANGE_PASSWORD_SUCCESS,
        payload: res.data
      })
      toast.success('Change password success. Please sign in again.');
    })
    .catch(err =>
      {
        toast.error(`${err.response.data.message}`);
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data
        })
    }
    );
};

export const resetPassword = (data) => dispatch => {
  axios
    .post('/api/users/recovery_password', data)
    .then(res => {
      dispatch({
        type: USER_RESET_PASSWORD_SUCCESS,
        payload: res.data
      })
      toast.success('Reset password success. Please check mail.');
    })
    .catch(err =>
      {
        toast.error(`${err.response.data.message}`);
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data
        })
    }
    );
};

// Login - Get User Token
export const loginUser = userData => dispatch => {
  axios
    .post('/api/users/login', userData)
    .then(res => {
      // Save to localStorage
      const { token } = res.data;

      if (token && token.slice(0, 7) === 'Bearer ') {
        const jwt = token.slice(7, token.length);
        if (userData.rememberMe) {
          localStorage.setItem('ccl-jwtToken', jwt);
        } else {
          localStorage.setItem('ccl-jwtToken', jwt);
        }
      }

      // Decode token to get user data
      const decoded = jwt_decode(token);
      // Set current user
      dispatch(setCurrentUser(decoded));
    })
    .catch(err => {
        toast.error("Login fail. Please check username/password again.");
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data
        })
      }
    );
};

// Set logged in user
export const setCurrentUser = decoded => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded
  };
};

// Log user out
export const logout = () => dispatch => {
  // Remove token from localStorage
  if (localStorage.getItem('ccl-jwtToken')) {
    localStorage.removeItem('ccl-jwtToken');
  }
  // Remove auth header for future requests
  // setAuthToken(false);
  // Set current user to {} which will set isAuthenticated to false
  dispatch({ type: USER_LOGOUT });
};

export const reset = () => dispatch => {
  dispatch({ type: USER_RESET });
};
// Set loading state
export const setGetUserInfoLoading = () => {
  return {
    type: GET_USER_INFO_LOADING
  };
};
